import React from 'react';
import useCompanyData from '../../context/company';
import { getRatingText } from '../../helpers/ratingLabels';

export function getMatrixCalibrationLabel(selection) {
    if (!selection?.is_manual) return 'Automática';
    if (selection?.score?.calibrated) return 'Comitê de Calibração';
    return 'Manual';
}

function ItemScoresTable({ title, items }) {
    if (!items?.length) return null;

    return (
        <div className="mt-3">
            <p className="fw-bold small mb-2">{title}</p>
            <div className="table-responsive rounded overflow-hidden border">
                <table className="table table-sm mb-0">
                    <thead className="table-light">
                        <tr>
                            <th>Item</th>
                            <th className="text-center">Avaliação</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((item, idx) => {
                            return (
                                <tr key={`${item.item_title}-${idx}`} className="align-middle">
                                    <td width="50%">{item.item_title || '—'}</td>
                                    <td className="text-center">
                                        {item.score ? (
                                            <span className="bg-green-light-50 p-2">
                                                {item.score_value != null ? (
                                                    <span>
                                                        {' '}{Number(item.score_value).toFixed(1)}
                                                    </span>
                                                ) : null}
                                            </span>
                                        ) : (
                                            '—'
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default function MatrixPerformanceSource({ selection }) {
    const { company } = useCompanyData();
    const src = selection?.performance_source;

    if (!src?.assessment_title) return null;

    const performanceLabel = getRatingText(src.final_evaluation, company)
        || getRatingText(src.manager_evaluation, company)
        || src.final_evaluation_display
        || src.manager_evaluation_display
        || src.expect_display;

    const hasItems = (src.objectives?.length || 0) + (src.competencies?.length || 0) > 0;

    return (
        <div className="mt-3 pt-2 border-top">
            <p className="fw-bold mb-2 text-green">Origem do quadrante</p>
            <div className="mt-2">
                <strong>Avaliação:</strong> {src.assessment_title}
            </div>
            {src.cycle_title ? (
                <div className="mt-2">
                    <strong>Ciclo:</strong> {src.cycle_title}
                </div>
            ) : null}
            {performanceLabel ? (
                <div className="mt-2">
                    <strong>Desempenho:</strong>{' '}
                    {performanceLabel}
                    {src.final_score_percent != null ? (
                        <span className="bg-green-light-50 p-2 ms-2">
                            {' '}{Number(src.final_score_percent).toFixed(1)}
                        </span>
                    ) : null}
                </div>
            ) : null}
            {src.potential_display ? (
                <div className="mt-2">
                    <strong>Potencial:</strong> {src.potential_display}
                </div>
            ) : null}
            {hasItems ? (
                <>
                    <ItemScoresTable title="Objetivos" items={src.objectives} />
                    <ItemScoresTable title="Competências" items={src.competencies} />
                </>
            ) : null}
        </div>
    );
}
